import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
const createSelectors = (parentReducer) => {
    return new (class {
        selectQualifications = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4AddUserWidget_reducer"];
            return reducer.qualifications;
        };
        selectDepartments = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4AddUserWidget_reducer"];
            return reducer.departments;
        };
        selectAreas = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4AddUserWidget_reducer"];
            return reducer.areas;
        };
        selectUserTypes = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4AddUserWidget_reducer"];
            return reducer.user_types;
        };
        selectRequesting = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4AddUserWidget_reducer"];
            return reducer.requesting;
        };
        selectAllUserTypes = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4AddUserWidget_reducer"];
            let userTypes = reducer.user_types;
            let listUserTypes = Object.keys(userTypes).map((listUserType) => {
                return listUserType;
            });

            return listUserTypes;
        };
        selectAllUsers = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4AddUserWidget_reducer"];
            return reducer.allUsers;
        };
        selectNickNames = ({ MainReducer }) => {
            return MainReducer.users;
        };

        selectAllNickNames = createSelector(
            [this.selectNickNames],
            (nickNames = false) => {
               

                let nameArray = []
                if(nickNames)
                {
                    Object.values(nickNames).map((user) => {
                        let deleted = user.profile.deleted ? user.profile.deleted : false;
                        if(typeof user.profile.nick_name === "undefined" || user.profile.nick_name === null || user.profile.nick_name === "" || deleted)
                        {
                            return null
                        }
                        else {
                            nameArray.push(user.profile.nick_name.toLowerCase())
                        }
                        return null;
                    })
                    return nameArray;
                }
                else {
                    return [];
                }
            })

            selectAllUserNames = createSelector(
                [this.selectNickNames],
                (nickNames = false) => {
                    let allNameArray = []
                    if(nickNames)
                    {
                        Object.values(nickNames).map((user) => {
                            let fname = user.profile.first_name
                            let lname = user.profile.last_name   
                            if(typeof user.profile.first_name === "undefined" || user.profile.first_name === null || user.profile.first_name === "" || user.profile.deleted === true )
                            {
                                return null
                            }
                            else {
                                allNameArray.push(`${fname} ${lname}`)
                            }
                            return null;
                        })
                        return allNameArray;
                    }
                    else {
                        return [];
                    }
                })

             
        selectAllUserEmails = createSelector(
            [this.selectAllUsers],
            (users = false) => {
                if (users) {
                    let emails = _.compact(
                        Object.keys(users).map((e) =>
                            !_.get(users[e].profile, "deleted")
                                ? _.get(users[e].profile, "email")
                                : false
                        )
                    );
                    return emails;
                } else {
                    return [];
                }
            }
        );
        selectAllUsersDetails = createSelector(
            [this.selectAllUsers],
            (users = false) => {
                if (users) {
                    let userInfo = Object.keys(users).map((e) => {
                        return _.get(users[e], "profile");
                    });
                    return userInfo;
                } else {
                    return false;
                }
            }
        );
        selectQualificationsPerCategoryAllUser = createSelector(
            [this.selectAllUsersDetails],
            (users = false) => {
                if (users) {
                    let qualificationsPerUser =
                        users &&
                        users.map((e) => {
                            let quals =
                                e.qualifications_per_user || false;
                                
                            return {
                                category: quals
                                    ? Object.values(quals).map((f) => {
                                          return f;
                                      })
                                    : false,
                                uid: e.uid,
                                name: e.first_name + " " + e.last_name,
                            };
                        });

                    if (qualificationsPerUser) {
                        let expDate1 = [];
                        Object.values(qualificationsPerUser).map((e) => {
                            let uid = e.uid;
                            let details = [];
                            if (e.category)
                                e.category.map((f) => {
                                    let qualification_title =
                                        f.qualification_title;
                                    let qualification_category =
                                        f.qualification_category;
                                    let user_name = e.name;
                                    let qualification_exp_date =
                                        f.qualification_exp_date;
                                    let expDate = moment(
                                        f.qualification_exp_date,
                                        "DD/MM/YYYY"
                                    );
                                    let currentDate = moment();
                                    let days = expDate.diff(
                                        currentDate,
                                        "days"
                                    );
                                    if (days < 90 && days > 0) {
                                        let detail = {
                                            qualification_title,
                                            qualification_category,
                                            user_name,
                                            qualification_exp_date,
                                            days,
                                        };
                                        details.push(detail);
                                        return details;
                                    }
                                    return null;
                                });
                            if (details.length > 0)
                                expDate1.push({ uid: uid, details: details });

                            return null;
                        });

                        return expDate1;
                    }
                } else {
                    return false;
                }
            }
        );
    })();
};

export default createSelectors;